__webpack_require__.p = "https://cdn.websky.aero/6R/static/";